// extracted by mini-css-extract-plugin
export default {"OutterDIV":"CatalogRendered_OutterDIV__2RzJu","catalogDIV":"CatalogRendered_catalogDIV__dYZ0z"};